import script from "./detailDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./detailDialog.vue?vue&type=script&setup=true&lang=ts"

import "./detailDialog.vue?vue&type=style&index=0&id=007b6b5f&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-007b6b5f"]])

export default __exports__